export default "__VITE_ASSET__DXLQJxD$__"